import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DefaultLogo from '../../images/default-avatar.jpg';
import { POST_STATUS, s3Link } from '../../utils/constants';
import { Link, useHistory, useParams } from 'react-router-dom';
import './style.css';
import CloseButton from '../CloseButton';

const PThankYou = ({ show, setShow, pu, isUpgrade = false }) => {
    const params = useParams();
    const history = useHistory();
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [avatar, setAvatar] = useState('');
    const [conversation, setConversation] = useState('');

    useEffect(() => {
        if (show) {
            getConversation();
        }
    }, [show]);

    const getConversation = () => {
        axios.get(`/api/conversations`, {
            params: {
                to: params.username ? params.username : pu.login,
            }
        })
            .then(response => {
                setConversation(response.data);
            }).catch(error => {
                console.log({ error });
            }).finally(() => {
            });
    };

    const handleSendMessage = (e) => {
        e.preventDefault();
        history.push(`/messages?conversation_id=${conversation.conversation_id}`);
    };

    useEffect(() => {
        let isMounted = true;
        let image = DefaultLogo;
        if (pu.profile_pic) {
            setAvatar(`${s3Link}/${pu.id}/profile_photo.jpg?t=${Date.now()}`);
        }

        return () => {
            return isMounted = false;
        };
    }, [pu]);

    const handleCloseThankYou = (e) => {
        e.preventDefault();
        // window.location.reload();
        setShow(false);
    };

    const goToProfile = (e, pu) => {
        e.preventDefault();
        history.push(`/${pu.login}`);
        setShow(false);
    };

    return (userInformation && <Modal show={show} onHide={handleCloseThankYou} className="modalThankYou" backdrop="static" centered>
        <Modal.Body>
            <CloseButton
                className="close"
                onClick={handleCloseThankYou}
                style={{ position: 'absolute', top: '12px', right: '12px' }}
            />
            <div className="thanku-message text-center">
                <h3>Thank you <span>{userInformation.login}</span> </h3>
                <h4>I appreciate your amazing support!</h4>
                <div className="thanku-user-img">
                    <span>
                        {
                            avatar
                                ? <Image
                                    src={avatar}
                                    className="pu__avatar"
                                    roundedCircle
                                />
                                : <svg style={{ backgroundColor: "#ffffff", height: '100px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#0097fe" d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z" /></svg>
                        }
                    </span>
                </div>
                <div className="thanks-user-name mt-3">{pu.login}<LazyLoadImage src="/images/tick_small_edit.png" style={{ marginBottom: '7px' }} /></div>
                <div className="thanks-user-email">@{pu.login}</div>
                {
                    isUpgrade
                        ? <div className="thanks-upgrade">
                            All the posts that were requiring a paid subscription, are now unlocked, except for PPV posts.
                        </div>
                        : null
                }
                <div className="btns-vup-msg thankyou-btns">
                    <a href="#" onClick={(e) => goToProfile(e, pu)} className="theme-btn theme-btn-bordered btn btn-primary">View profile</a>
                    <a id="thank_profile_ancr" href="#" onClick={handleSendMessage} className="theme-btn theme-btn-bordered btn btn-primary">Message</a> </div>
                <p>View my <a className="" href={`/${pu.login}`}>profile</a> and enjoy all my premium private posts!</p>
                <p><a href="#" onClick={handleSendMessage}>Message</a> me to request custom pay per view content :)</p>
            </div>
        </Modal.Body>
    </Modal>);
};

export default PThankYou;
